
import Vue from "vue"
import MenuItem from '@/components/Aside/menuItem/index.vue'
import { TIcon } from '@/components/icon'
import Icon from '@/components/icon/index.vue'
import { IRouteItem } from './types'
import { mapGetters } from 'vuex'
import { RouteItem } from '@/store/route/getDisplayRouteTree'

export default Vue.extend({
	components: {
		MenuItem,
		Icon
	},

	//    mounted(){
	// 	console.log(this.routes);

	//    },
	// methods: {
	// 	toPage(item: IRouteItem) {
	// 		console.log(item);

	// 		this.$store.dispatch("routeStore/changeRoute", item)
	// 	}
	// },
	computed: {
		...mapGetters({
			routes: 'routeStore/currentRoutes'
		}) as {
			routes: () => RouteItem[]
		}
	}
})
